import ContactSalesButtonNew from '../_core/contactSales/ContactSalesButtonNew';
export default ContactSalesButtonNew;